<template>
  <div>
    {{ this.LabChangVn }}
    <b-alert
      show
      variant="dark"
      class="margin-bottom font12px"
      v-if="this.LabHeadData != '' && this.LabHeadData != null"
    >
      <h5
        class="cursor-pointer font-color-link1"
        @click="LabOpen(ptHN, ptVN, '')"
      >
        Lab Report
      </h5>
      <b-row
        v-for="item in this.LabHeadData"
        v-bind:key="item.id"
        class="margin-bottom"
      >
        <b-col lg="12">
          <b-alert show variant="warning">
            <p>
              <b-row>
                <b-col lg="12">
                  <strong
                    @click="LabOpen(ptHN, ptVN, item.lab_order_number)"
                    style="color:#007bff;"
                    class="cursor-pointer"
                  >
                    Lab Report : {{ item.lab_order_number }} | Confirm Report :
                    {{ item.datas.confirm_report }}

                    <br />Lab Form : {{ item.datas.form_name }}
                  </strong>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="6"
                  >Order Date :
                  {{
                    thaiDatetimeFc.ThaiDateTime(
                      item.datas.order_date + " " + item.datas.order_time
                    )
                  }}</b-col
                >
                <b-col lg="6"
                  >Report Date :
                  {{
                    thaiDatetimeFc.ThaiDateTime(
                      item.datas.report_date + " " + item.datas.report_time
                    )
                  }}</b-col
                >
              </b-row>
            </p>
            <b-table
              id="table-transition-example"
              :items="
                (GetLabReport(item.lab_order_number, item.hn) &&
                  GetLabReport(item.lab_order_number, item.hn).LabItemData) ||
                  null
              "
              :fields="
                (GetLabReport(item.lab_order_number, item.hn) &&
                  GetLabReport(item.lab_order_number, item.hn).LabfieldsData) ||
                  null
              "
              striped
              hover
              small
              @row-selected="rowSelected"
              class="border-radius"
            ></b-table>

            <hr class="hr-custom" />
            <b-row>
              <b-col lg="6">
                <h6 v-if="item.datas.order_note" class="font-color-danger">
                  <strong>Order Note :</strong> {{ item.datas.order_note }}
                </h6>
              </b-col>
              <b-col lg="6">
                <h6 v-if="item.datas.result_note" class="font-color-danger">
                  <strong>Lab Note :</strong> {{ item.datas.result_note }}
                </h6>
              </b-col>
            </b-row>
          </b-alert>
        </b-col>
      </b-row>
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import PatientLabHead from "@/models/patientEMRs/PatientLabHead";
import PatientLabReport from "@/models/patientEMRs/PatientLabReport";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

import PatientWebbaseUrl from "@/models/patientEMRs/PatientWebbaseUrl";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      transProps: {
        // Transition name
        name: "flip-list"
      },
      vnStart: "",
      LabHeadData: null,
      LabReportData: null,
      thaiDatetimeFc: null,
      ptHN: "",
      ptVN: "",
      ptAN: "",
      ptRowLimit: "",
      DataCh: "",
      LabUrl: "",
      UserId: ""
    };
  },
  props: ["MyVn", "MyHn", "MyAn", "RowLimit"],
  component: {
    PatientLabHead,
    PatientLabReport,
    thaiDatetime,
    PatientWebbaseUrl
  },
  created() {
    this.LabChangVn, (this.thaiDatetimeFc = thaiDatetime.methods);
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {
    ptHN: function() {
      // this.SetLabReport(this.ptVN,this.ptHN)
    },
    ptVN: function() {
      this.SetLabReport(this.ptVN, this.ptHN, this.ptAN);
      this.GetLabUrl();
    },
    ptAN: function() {
      this.SetLabReport(this.ptVN, this.ptHN, this.ptAN);
      this.GetLabUrl();
    }
  },
  computed: {
    LabChangVn: function() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
      this.ptAN = this.MyAn;
      this.ptRowLimit = this.RowLimit;

      /*

        if((this.vnStart != this.$store.get('systems@vnEMR')) || ((this.LabHeadData == null || this.LabHeadData == '') && PatientLabHead.all() != '')){

          this.vnStart = this.$store.get('systems@vnEMR')

          let resultData = this.SetLabReport(this.$store.get('systems@vnEMR'))

          if(resultData != '' && resultData != '[]' && resultData != null){
            this.LabReportData = resultData
            return resultData
          } else {
            return null
          }

        } else {
          if(this.LabReportData != '' && this.LabReportData != null){

            if(this.LabHeadData[0].hn == this.$store.get('systems@hnEMR')){
              return this.LabReportData
            } else {
              return null
            }

          } else {
            return null
          }
        }
        */
    }
  },
  methods: {
    SetLabReport(vn, hn, an) {
      if (
        PatientLabHead.query()
          .where("hn", hn)
          .where("department", "IPD")
          .get()[0]
      ) {
        let LabHeadObj = [];

        if (this.ptRowLimit != "0") {
          LabHeadObj = PatientLabHead.query()
            .where(record => record.datas.hn == hn)
            .where(record => record.datas.an == an)
            .where("department", "IPD")
            .orderBy("list_orderby", "desc")
            .limit(this.ptRowLimit)
            .get();
        } else {
          LabHeadObj = PatientLabHead.query()
            .where(record => record.datas.hn == hn)
            .where(record => record.datas.an == an)
            .where("department", "IPD")
            .orderBy("list_orderby", "desc")
            .get();
        }

        this.LabHeadData = LabHeadObj;

        // for (let i = 0; i < LabHeadObj.length; i++) {
        if (LabHeadObj.length > 0) {
          let LabReportObj = this;
          this.axios
            .post(this.$store.get("systems@UrlApi") + "LabReportData", {
              CompanyId: this.$store.get("systems@CompanyId"),
              ApiKey: this.$store.get("systems@ApiKey"),
              hn: hn,
              an: an
              // lab_order_number: LabHeadObj[i].lab_order_number,
            })
            .then(function(response) {
              LabReportObj.output = response.data;
              if (LabReportObj.output.status === true) {
                PatientLabReport.delete({
                  where(record) {
                    return record.an == an;
                  }
                });

                let data = [];
                for (var val of LabReportObj.output.result) {
                  data.push({
                    id: val.lab_order_number + val.lab_items_code,
                    lab_order_number: val.lab_order_number,
                    hn: val.hn,
                    vn: val.vn,
                    an: val.an,
                    datas: val
                  });
                }

                PatientLabReport.insertOrUpdate({
                  data
                });
                /*
                      for (var val of LabReportObj.output.result) {
                          PatientLabReport.insertOrUpdate({
                              data: 
                              {
                                id : val.lab_order_number+val.lab_items_code,
                                lab_order_number : val.lab_order_number,
                                hn : val.hn,
                                vn : val.vn,
                                an : val.an,
                                datas : val,
                              }
                          })
                      }*/
              } else {
                if (LabHeadObj.output.ErrorMessage === "Data Not Found") {
                  PatientLabReport.delete({
                    where(record) {
                      return record.an == an;
                    }
                  });
                }
              }
            })
            .catch(function(error) {
              LabHeadObj.output = error;
              console.log("LabReportData : " + LabReportObj.output);
            });
        }

        this.vnStart = vn;

        this.LabHeadData = LabHeadObj;
      }
    },
    GetLabReport(lab_order_number, hn) {
      let GetLabReportObj = PatientLabReport.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.lab_order_number == lab_order_number)
        .where(record => record.datas.confirm == "Y")
        .get();

      let LabItemData = [];

      for (let i = 0; i < GetLabReportObj.length; i++) {
        LabItemData.push({
          lab_items_name: GetLabReportObj[i].datas.lab_items_name,
          lab_order_result: GetLabReportObj[i].datas.lab_order_result,
          lab_items_normal_value_ref:
            GetLabReportObj[i].datas.lab_items_normal_value_ref
        });
      }

      let LabfieldsData = [
        { label: "Lab Name", key: "lab_items_name", sortable: true },
        { label: "Lab Result", key: "lab_order_result", sortable: true },
        {
          label: "Lab Result Normal",
          key: "lab_items_normal_value_ref",
          sortable: true
        }
      ];

      let TableLabReport = [];
      TableLabReport.push({
        LabItemData: LabItemData,
        LabfieldsData: LabfieldsData
      });

      return TableLabReport[0];
    },
    rowSelected(items) {
      this.selected = items;
    },
    GetLabUrl() {
      let UrlObj = PatientWebbaseUrl.query()
        .where(record => record.web_name == "LAB_Alert")
        .get();

      if (UrlObj.length > 0) {
        this.LabUrl = UrlObj[0].web_host;
      }

      if (this.$store.get("systems@LoginData")) {
        this.UserId = this.$store.get("systems@LoginData").UserId;
      }
    },
    LabOpen(hn, vn, lab_order_number) {
      let param = {
        hn: hn,
        vn: vn,
        lab_order_number: lab_order_number,
        user_id: this.$store.get("systems@LoginData").UserId
      };

      if (
        hn != "" &&
        vn != "" &&
        this.LabUrl != "" &&
        this.LabUrl != null &&
        this.$store.get("systems@LAB_REPORT_OUT_LINK") == "Y"
      ) {
        this.pjFunctionsFc.OpenWindowWithPost(
          this.LabUrl,
          "width=1200,height=600,left=100,top=10,resizable=yes,scrollbars=yes",
          hn + lab_order_number,
          param
        );
      }
    }
  }
})
export default class EmrLabIPD extends Vue {}
</script>

<style lang="scss">
</style>

